<template>
  <div class="flex relative z-0">
    <Tooltip
      v-for="(user, index) in users.slice(0, maxAvatars)"
      :key="index"
      :title="user.fullname"
      class="flex items-center"
      side="bottom"
      triggerAs="span"
      disableHoverableContent
      ignoreNonKeyboardFocus
      useCustomSlot
    >
      <Avatar
        :src="user.avatar_url"
        :name="user.fullname"
        :size="size"
        :initials="user.avatar_initials"
        :class="cn(avatarGroupVariants({ size }))"
      />
    </Tooltip>

    <Tooltip
      v-if="users.length > maxAvatars"
      class="flex items-center"
      side="bottom"
      triggerAs="span"
      disableHoverableContent
      ignoreNonKeyboardFocus
      useCustomSlot
    >
      <Avatar
        :initials="'+' + (users.length - maxAvatars)"
        :size="size"
        :class="cn(avatarGroupVariants({ size }))"
      />
      <template #content>
        <p class="text-white text-style-xs font-semibold max-w-[280px]">
          {{ additionalUsersTooltip }}
        </p>
      </template>
    </Tooltip>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { cn } from "@/Utils/cn";
import { Avatar, avatarGroupVariants } from "@/SharedComponents/Avatars";
import { Tooltip } from "@/SharedComponents/Tooltips";

const props = defineProps({
  users: { type: Array, required: true },
  size: { type: String, required: false },
  maxAvatars: { type: Number, required: false, default: 3 },
});

const additionalUsersTooltip = computed(() => {
  return props.users
    .slice(props.maxAvatars)
    .map((user) => user.fullname)
    .join(", ");
});
</script>
